// Search bar open & close
var searchIcon = $("#wz-search-icon")[0];
$(searchIcon).click(function () {
  $(this).parent().parent().toggleClass("wz-search-bar-opened");
  setTimeout(() => {
    var input = $(".wizzy-search-input")[0];
    $(input).focus();
    $(input).click();
  }, 0);
});
window.onWizzyScriptLoaded = function () {
  $("body").on("focus", ".wizzy-search-input", function () {
    $("body").addClass("wz-wrapper-opened");
  });
  $("body").on("blur", ".wizzy-search-input", function () {
    $("body").removeClass("wz-wrapper-opened");
  });

  // Replacing default template
  // replaceTemplate("wizzy-search-results-product");
  replaceTemplate("wizzy-autocomplete-topproducts");

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function(payload){
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      return payload;
    }
  )

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      payload.forEach((product) => {
        if (product.sellingPrice) {
          try {
            var offerPrice = parseFloat(product.sellingPrice.replace(/,/g, ""));
          } catch (e) {
            console.log(e);
          }
          var offerPrice_ = offerPrice - (offerPrice * 10) / 100;
          product.offerPrice__ = Math.ceil(
            offerPrice_ - (offerPrice_ * 5) / 100
          );
        }
      });


      payload.forEach(product => {
        if(product.swatches){
          if(product.swatches.length > 0){
            var sizes = product.swatches[0].values;
            if(sizes.length > 0 && sizes){
              sizes = sizes.filter(item => item.inStock === true);
              product.swatches[0].values = sizes;
            }
            // console.log(sizes);
          }
        }
      })

      payload.forEach((product) => {
          // Check if the last three characters of price are '.00' and remove them if necessary
          if(product.price){
            if (product.price.endsWith('.00')) {
              product.price = product.price.slice(0, -3);
            }
          }
          if(product.sellingPrice) {
            if (product.sellingPrice.endsWith('.00')) {
              product.sellingPrice = product.sellingPrice.slice(0, -3);
            }
          }
          if (product.discount){
            if (product.discount.endsWith(".00")) {
              product.discount = product.discount.slice(0, -3); // Remove the last three characters
            }
            var discountPrice = product.discount;
            if(discountPrice){
              product.discount = discountPrice.replace(/,/g, '');
            }
          }
      });
      
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      let x = document.querySelector(".wizzy-body-end-wrapper");
      if (
        x &&
        typeof data.isForDefault !== "undefined" &&
        data.isForDefault === true
      ) {
        x.classList.add("wizzy-view-more-hide");
      } else if (x && x.classList.contains("wizzy-view-more-hide")) {
        x.classList.remove("wizzy-view-more-hide");
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function(payload){
      console.log(payload,"BEFORE_SEARCH_EXECUTED");
      // payload.inStock = ["true","false"];

     let closeButton = document.querySelector(".search__button[aria-label='Close']");
     if(closeButton) closeButton.click();

      const body = document.querySelector('body');
      if (body) {
          body.classList.remove('predictive-search--focus');
      } else {
      }
      
      return payload;
    }
  )

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function(payload){
      console.log(payload,"BEFORE_FILTERS_EXECUTED");
      // payload.filters.inStock = ["true","false"];
      return payload;
    }
  )

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      $(".st-search-bar.custom-desktop").hide();
      return payload;
    }
  );
};

// Declaration of template replace function
const replaceTemplate = (div) => {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};
